import React from 'react'

interface ErrorProps {
  message: string
  onRetry?: () => void
}

export const Error: React.FC<ErrorProps> = ({ message, onRetry }) => {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-red-200 bg-red-50 p-8">
      <h3 className="mb-2 text-lg font-semibold text-red-800">
        Error al cargar datos
      </h3>

      <p className="mb-4 max-w-md text-center text-red-700">{message}</p>

      {onRetry && (
        <button
          onClick={onRetry}
          className="rounded-lg bg-red-600 px-4 py-2 text-white transition-colors duration-150 hover:bg-red-700"
        >
          Intentar de nuevo
        </button>
      )}
    </div>
  )
}
